import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useScroll, useSpring } from 'framer-motion';
import { Lock, ArrowRight, ShieldCheck, Zap } from 'lucide-react';
export function LuxuryStickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleBuy = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Plan B Migratorio',
        content_type: 'product',
        value: 6.95,
        currency: 'USD'
      });
    }
    window.open('https://www.simplementemejor.com/cart/51706800537880:1', '_blank');
  };
  return <>
      {/* Scroll progress bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[51]" style={{
      scaleX,
      background: 'linear-gradient(90deg, var(--accent), var(--accent-hover))'
    }} data-id="element-240" />

      {/* Floating bottom CTA bar */}
      <AnimatePresence data-id="element-241">
        {isVisible && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="fixed bottom-0 left-0 right-0 z-40" data-id="element-242">
            {/* Gradient fade edge */}
            <div className="h-6 bg-gradient-to-t from-[#0a1628] to-transparent pointer-events-none" data-id="element-243" />

            <div className="bg-[#0a1628]/95 backdrop-blur-md border-t border-[var(--accent)]/25 shadow-[0_-4px_30px_rgba(0,0,0,0.3)]" data-id="element-244">
              <div className="max-w-[580px] mx-auto px-4 py-3 flex items-center gap-3" data-id="element-245">
                {/* Book thumbnail */}
                <img src="https://cdn.magicpatterns.com/uploads/3n4ds5BYVTxsq9t4FEGGRH/cover_2.png" alt="Método" className="w-11 h-14 rounded object-cover border border-[var(--accent)]/30 shadow-md flex-shrink-0 hidden sm:block" data-id="element-246" />

                {/* Price info */}
                <div className="flex-shrink-0 hidden sm:block" data-id="element-247">
                  <p className="text-[10px] text-[#faf7f2]/50 uppercase tracking-wider leading-none" data-id="element-248">
                    Kit completo
                  </p>
                  <div className="flex items-baseline gap-1.5" data-id="element-249">
                    <span className="text-[#faf7f2]/40 line-through text-xs" data-id="element-250">
                      $97
                    </span>
                    <span className="text-[var(--accent)] font-serif font-bold text-lg leading-none" data-id="element-251">
                      $6.95
                    </span>
                  </div>
                </div>

                {/* CTA Button */}
                <motion.button onClick={handleBuy} whileTap={{
              scale: 0.97
            }} className="flex-1 py-3 px-4 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#faf7f2] font-bold text-sm rounded-lg flex items-center justify-center gap-2 shadow-lg relative overflow-hidden group whitespace-nowrap" data-id="element-252">
                  <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-253" />
                  <Lock className="w-3.5 h-3.5 relative z-10 flex-shrink-0" data-id="element-254" />
                  <span className="relative z-10 uppercase tracking-wide text-xs sm:text-sm" data-id="element-255">
                    ACTIVAR MI PLAN B — $6.95
                  </span>
                </motion.button>
              </div>

              {/* Trust micro-badges */}
              <div className="flex items-center justify-center gap-4 pb-2 text-[9px] text-[#faf7f2]/40" data-id="element-256">
                <span className="flex items-center gap-1" data-id="element-257">
                  <ShieldCheck className="w-2.5 h-2.5" data-id="element-258" /> Garantía 30 días
                </span>
                <span className="opacity-30" data-id="element-259">·</span>
                <span className="flex items-center gap-1" data-id="element-260">
                  <Zap className="w-2.5 h-2.5" data-id="element-261" /> Acceso inmediato
                </span>
                <span className="opacity-30" data-id="element-262">·</span>
                <span className="flex items-center gap-1" data-id="element-263">
                  <Lock className="w-2.5 h-2.5" data-id="element-264" /> Pago seguro
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}